import { Check, Loader2 } from "lucide-react";
import { stagesFor } from "@/lib/research";
import { cn } from "@/lib/utils";

export function ResearchProgress({ depth, stage, plan, compact = false }) {
  const stages = stagesFor(depth, plan);
  const current = stages.findIndex((s) => s.key === stage);
  return (
    <ol className={cn("flex flex-wrap items-center gap-x-1 gap-y-2", compact ? "text-[12px]" : "text-[13px]")} data-testid="research-progress" data-stage={stage}>
      {stages.map((s, i) => {
        const done = stage === "done" || i < current;
        const active = i === current;
        return (
          <li key={s.key} className="flex items-center gap-1" data-testid={`research-stage-${s.key}`} data-state={done ? "done" : active ? "active" : "pending"}>
            <span className={cn("flex h-5 w-5 items-center justify-center rounded-full border", done ? "border-white/20 bg-white text-ink-950" : active ? "border-white/40 text-white" : "border-white/10 text-zinc-600")}>
              {done ? <Check className="h-3 w-3" strokeWidth={3} /> : active ? <Loader2 className="h-3 w-3 animate-spin" /> : <span className="h-1 w-1 rounded-full bg-current" />}
            </span>
            <span className={cn(done ? "text-zinc-400" : active ? "text-white" : "text-zinc-600")}>{s.label}</span>
            {i < stages.length - 1 && <span className="mx-1.5 h-px w-4 bg-white/10 sm:w-6" />}
          </li>
        );
      })}
    </ol>
  );
}

export function PlanQueries({ queries }) {
  if (!queries?.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="research-plan">
      {queries.map((q, i) => (
        <span key={q} className="rounded-full border border-white/[0.08] bg-ink-900 px-2.5 py-1 text-[12px] text-zinc-400" data-testid={`research-plan-query-${i}`}>
          {q}
        </span>
      ))}
    </div>
  );
}
